export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">平台介绍</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
              关于我们
            </h2>
          </div>

          <div className="p-6 md:p-10 rounded-2xl bg-background-50 border border-background-200/60">
            <div className="prose prose-sm max-w-none">
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                <strong className="text-foreground-900">吃瓜视频在线观看</strong>是一个专注于娱乐八卦资讯聚合的在线平台。我们汇聚了51吃瓜在线、吃瓜在线等主流吃瓜平台的精华内容，致力于为吃瓜群众在线提供最新、最全、最热门的八卦资讯。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                无论是娱乐圈的明星动态、网红圈的爆料争议，还是综艺节目的名场面合集、影视剧的幕后花絮，甚至是社会热点的热议话题，你都能在这里一站式获取。瓜田每日更新，让你随时随地享受在线吃瓜的乐趣。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                我们坚持内容为王的运营理念，所有资讯经过严格筛选和整理，确保每一条吃瓜内容都有据可循。同时，我们高度重视用户体验和隐私保护，浏览无需注册，让你安心吃瓜、放心看热闹。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                吃瓜视频在线观看——你身边的吃瓜第一站，千万吃瓜群众的选择。我们承诺：每日更新、内容丰富、安全可靠。欢迎广大吃瓜群众在线围观，一起享受看热闹的快乐！
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}